import React from "react";
import { Helmet } from "react-helmet";
import Category from "./Category/Category";
import Landing from "./Landing/Landing";
import Banner from "./Banner/Banner";
import Project from "./Projects/Project";
import DeveService from "./Development-service/Deve-serivice";
import Collage from "./Collage-slider/Collage";
import Card from "./Card/Card";
import Review from "./Reviewslider/Review";
import Payment from "./Paymentpage/Payment";
import Video from "./Video/Video";
import Increment from "./Increament/Increament";

import "./Home.scss";

const Home = () => {
  return (
    <>
      <Helmet>
        <title>Best Software Company in Vadodara | V-Ex Tech Solution</title>
        <meta
          name="title"
          content="Best Coding & Software Training Company in Vadodara - V-Ex Tech Solution"
        />
        <meta
          name="description"
          content="V-Ex Tech Solution offers expert-led IT training and internship programs in Vadodara. Learn Python, MERN Stack, Data Analysis, Web Development, and more with 100% practical learning experience."
        />
        <meta
          name="keywords"
          content="software company in Vadodara, coding classes in Vadodara, IT training, Python course Vadodara, MERN stack internship, web development course, V-Ex Tech Solution"
        />
        <meta name="author" content="V-Ex Tech Solution" />
      </Helmet>

   
     

      {/*  Sections */}
      <Category />
      <Landing />
      <Banner />
      <Project />
      <DeveService />
      <Collage />
      <Card />
      <Review />
      <Payment />
      <Video />
      <Increment />
    </>
  );
};

export default Home;
